import { useCallback, useRef } from 'react';
import { useLatestCallback } from './useLatestCallback';

export function useResizeObserver(
  callback: () => void,
): // eslint-disable-next-line no-unused-vars
(node: Element | null) => void {
  const cb = useLatestCallback(callback);
  const observerRef = useRef<ResizeObserver | null>(null);

  return useCallback(
    (node: Element | null) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }

      if (node && typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(cb);
        observer.observe(node);
        observerRef.current = observer;
      }
    },
    [cb],
  );
}
